export default "__VITE_ASSET__636541e3__"